import Eyebrow from '@Guidelines/Component/Eyebrow';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

const rowStyle = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.875rem;
	flex-wrap: wrap;
`;

const labelStyle = css`
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.ink};
`;

type Props = {
	/** Rank of the field among all the fields of the draft, archived ones included. */
	readonly index: number;
	readonly label: string;
	readonly natureLabel: string;
	readonly isReadOnly: boolean;
	readonly onRestore: (index: number) => void;
};

/** One archived field: its label, its nature and the way to restore it. */
const ArchivedFieldRow: React.FC<Props> = ({ index, label, natureLabel, isReadOnly, onRestore }) => {
	const handleRestoreClick = React.useCallback(() => {
		onRestore(index);
	}, [onRestore, index]);

	return (
		<div css={rowStyle}>
			<span css={labelStyle}>{label}</span>
			<Eyebrow>{natureLabel}</Eyebrow>
			<Button
				type="button"
				size="sm"
				severity="secondary"
				label="Restaurer"
				disabled={isReadOnly}
				onClick={handleRestoreClick}
			/>
		</div>
	);
};

export default ArchivedFieldRow;
